import { get } from "partial.lenses";

// Config
export const getTurnstileSiteKey = state =>
  get(["config", "turnstileSiteKey"], state);
export const getTurnstileVerifyURL = state =>
  get(["config", "turnstileVerifyURL"], state);
